import { PageHeader, PageHero } from '@/shared/ui/Layout'
import { RewardBadge } from '@/shared/ui/RewardBadge'

import type { WalletExtractBalance } from '../model/types'

type WalletExtractHeroProps = {
  title: string
  wallet: WalletExtractBalance
}

export const WalletExtractHero = ({ title, wallet }: WalletExtractHeroProps) => (
  <>
    <PageHeader title={title} />

    <PageHero
      art="/icons/coins.png"
      artFit="contain"
      backgroundImage="/missions/hero-bg.jpg"
      className="mb-0"
    >
      <PageHero.Title>Seu saldo atual</PageHero.Title>
      <PageHero.Subtitle>
        <RewardBadge.Group>
          <RewardBadge type="xp" value={wallet.points} variant="inline" />
          <RewardBadge type="coins" value={wallet.coins} variant="inline" />
        </RewardBadge.Group>
      </PageHero.Subtitle>
      <PageHero.Subtitle>
        <span>Acompanhe abaixo cada ganho ou uso de recompensas.</span>
      </PageHero.Subtitle>
    </PageHero>
  </>
)
